export default __webpack_public_path__ + "2019 An instrument-free demonstration of quantum key distribution for high-school students.pdf";